/* eslint-disable */ const Env = {BUILD_COMMIT_ID: 'e61a3de7f5b8ab13cf153a207b787f18aaaa52a8', BUILD_JOB_ID: '0000000694', ADVANCED_RECIPE_EDITOR_ENABLED: false, STRIPE_TEST_MODE: false};export default Env;
